import { render, staticRenderFns } from "./ListFeed.vue?vue&type=template&id=2caac3ac&"
import script from "./ListFeed.vue?vue&type=script&lang=js&"
export * from "./ListFeed.vue?vue&type=script&lang=js&"
import style0 from "./ListFeed.vue?vue&type=style&index=0&id=2caac3ac&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports